import script from "./Category.vue?vue&type=script&lang=ts&setup=true"
export * from "./Category.vue?vue&type=script&lang=ts&setup=true"

import "./Category.vue?vue&type=style&index=0&id=e155b532&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e155b532"]])

export default __exports__